import { SWITCH_MODES } from "../constants/switchModes";

function switchModeToLabel(debugMode) {
  return SWITCH_MODES[debugMode];
}

export { switchModeToLabel };
